import { render, staticRenderFns } from "./ModalAgenda.vue?vue&type=template&id=fa3277fc&scoped=true&lang=pug"
import script from "./ModalAgenda.vue?vue&type=script&lang=js"
export * from "./ModalAgenda.vue?vue&type=script&lang=js"
import style0 from "./ModalAgenda.vue?vue&type=style&index=0&id=fa3277fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa3277fc",
  null
  
)

export default component.exports